import React  from 'react'; 
import './Navbar.css'; 
import ThemeToggleButton from './ThemeToggleButton.js'; 

const NavbarExam = () => {
    return ( 
        <nav className="navbar2">
            <div className="container">
            <ThemeToggleButton />

            </div>
        </nav>)
}

export default NavbarExam